import React, { useState, useEffect, useContext, useRef } from 'react'
import ContractTable from './ContractTable'
import {
  getStewards,
  getAssignmentsByUserId,
  getAllfilteredContractYears,
  getSalesYear,
  getHighestRole,
  getLinkCompanies,
  getContractFromResellerId,
  getAllLinkedContractYears,
  getProductionPlan
} from '../../services/apiHelper'
import { Modal } from 'syngenta-react-components'
//import { GlobalContext, AuthContext } from '../../services/context'
import { AuthContext } from '../../services/context'
import UpdateProfileView from '../UpdateProfile/UpdateProfileView'
import StewardshipTable from './StewardshipTable'
import {
  yearsOptionFactory
} from '../../services/utils'

const ContractDashboard = ({ match, history }) => {
  //const { dispatch, trackEvent } = useContext(GlobalContext)
  const { auth, hasAccess } = useContext(AuthContext)
  const [tableData, setTableData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [stewardData, setStewardData] = useState([])
  const [contractStatus, setContractStatus] = useState('LOADING')
  const [stewardStatus, setStewardStatus] = useState('LOADING')
  const [hasPermissison, setHasPermissions] = useState('LOADING')
  const [hasStewardPermission, setHasStewardPermission] = useState('LOADING')
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortByKey, setSortByKey] = useState()
  const [limit, setLimit] = useState(50)
  const INIT_CONTRACT_LIMIT = 50
  const [contractYear, setContractYear] = useState('')
  const [statusArr, setStatusArr] = useState(['pending','pendinggrowersigned','amendment_pending','amendmentpendinggrowersigned','completed','amendment_completed'])
  const [loadingData, setLoadingData] = useState(false)
  const [isyearStatus, setIsyearStatus] = useState(false)
  const [allYearOptions, setAllYearOptions] = useState([])
  const [highestRole, setHighestRole] = useState('')
  const [statusDisable, setStatusDisable] = useState(true)

  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    getSalesYear()?.then(sales_year => {
      setContractYear(sales_year?.data?.sales_year)
      const MAX_YEARS = 1
      const MIN_YEARS = -4
      const yearsOptions = yearsOptionFactory(parseInt(sales_year?.data?.sales_year), MIN_YEARS, MAX_YEARS)
      setAllYearOptions(yearsOptions)
    })
  }, [])

  useEffect(() => {
    getHighestRole()?.then(highestRoleData => {
      setHighestRole(highestRoleData)
    })
  }, [])

  useEffect(() => {
    if (!auth.userInfo.user_id) return
    getStewards(auth.userInfo.user_id)?.then(res => {
      if (!canceled.current) {
        if (res?.length) {
          setStewardStatus()
        } else {
          setStewardStatus('EMPTY')
        }
        setStewardData(res)
      }
    })
  }, [auth.userInfo.user_id, hasAccess])

  useEffect(() => {
    if (
      process.env.REACT_APP_STAGE === 'prod' ||
      process.env.REACT_APP_STAGE === 'uat'
    ) {
      if (auth?.userInfo?.user_id && window?.FS?.identify) {
        window.FS.identify(auth.userInfo.user_id.toString())
      }
    }

    if (
      auth.userInfo?.user_id &&
      (!auth.userInfo.first || !auth.userInfo.last)
    ) {
      setShowModal(true)
    }
  }, [auth, auth.userInfo])

  useEffect(() => {
    setHasPermissions(hasAccess('ANY', 'create-contract'))
    setHasStewardPermission(hasAccess('ANY', 'is-steward'))
  }, [hasAccess])

  // const pushNewContract = () => {
  //   trackEvent('create_contract_clicked', { from: 'contractDashboard' })
  //   const dispatchObj = { type: 'GO_TO_CREATE_CONTRACT', payload: { detailView: { title: 'New contract', previous: 'Dashboard' } } }
  //   dispatch(dispatchObj)
  // }

  let detailViewButton = null
  if (hasPermissison === 'SUCCESS') {
    detailViewButton = (
      <div data-testid="createNewContractButton">
        {/* <Button
          type="success"
          text="Create new contract"
          clickHandler={pushNewContract}
          customClassName="mb0"
        ></Button> */}
      </div>
    )
  }

  const customSort = (data, dataKey, sortBy) => {
    if (data?.length && dataKey) {
      setSortOrder(sortBy)
      setSortByKey(dataKey)
      let newTableData = []
      if (dataKey === 'created_date' && sortBy === 'asc') {
        newTableData = [...data].sort(function (a, b) {
          return new Date(a.created_date) - new Date(b.created_date)
        })
      } else if (dataKey === 'created_date') {
        newTableData = [...data].sort(function (a, b) {
          return new Date(b.created_date) - new Date(a.created_date)
        })
      } else if (sortBy === 'asc') {
        newTableData = [...data].sort((a, b) => {
          return a[dataKey]?.toLowerCase() > b[dataKey]?.toLowerCase() ? 1 : -1
        })
      } else {
        newTableData = [...data].sort((a, b) => {
          return a[dataKey]?.toLowerCase() > b[dataKey]?.toLowerCase() ? -1 : 1
        })
      }
      return newTableData
    }
    return data || []
  }

  const getMoreContracts = () => {
    if(!isyearStatus) {
      let newLimit = limit + 50
      let status = statusArr.toString()
      let year
      if(contractYear === 'Select Year'){
        year = ''
      } else {
        year = contractYear
      }

      let resellerCompany = []
      if (highestRole && (highestRole.role_name === 'sales-representative' || highestRole.role_name === 'district-manager'))  {
        getLinkCompanies(highestRole.company_id).then(result => {
          resellerCompany = result?.filter(item => { return item.type === 'reseller' })
          let resellerID = []
          resellerID = resellerCompany.map(data=>{
            return data.id
          })
          let concatVal = []
          getContractFromResellerId(year, newLimit, status, resellerID).then(resReseller => {
            if (resReseller && resReseller.length) {
              concatVal=[...resReseller]
            }
            setStatusDisable(true)
            getAllfilteredContractYears(year, newLimit, status).then(res => {
              if (res && res.length) {
                if(concatVal.length)
                  concatVal=[...concatVal,...res]
                else
                  concatVal=[...res]
              }
              if (concatVal && concatVal.length) {
                setTableData(customSort(concatVal, sortByKey, sortOrder))
              }
              setStatusDisable(false)
            })
          })
        })
      } else {
        setStatusDisable(true)
        getAllfilteredContractYears(year, newLimit, status).then(res => {
          if (res && res.length) {
            setTableData(customSort(res, sortByKey, sortOrder))
          }
          setStatusDisable(false)
        })
      }
      setLimit(newLimit)
    }
  }

  useEffect(() => {
    let year
    if(contractYear === 'Select Year'){
      year = ''
    } else {
      year = contractYear
    }
    setLimit(INIT_CONTRACT_LIMIT)
    let status = statusArr.toString()
    setContractStatus('LOADING')
    setLoadingData(true)

    let resellerCompany = []
    if (auth.userInfo.user_id && hasAccess() === 'SUCCESS') {
      if (highestRole && (highestRole.role_name === 'sales-representative' || highestRole.role_name === 'district-manager'))  {
        setStatusDisable(true)
        getLinkCompanies(highestRole.company_id).then(result => {
          resellerCompany = result?.filter(item => { return item.type === 'reseller' })
          let resellerID = []
          resellerID = resellerCompany.map(data=>{
            return data.id
          })
          let concatVal = []
          getContractFromResellerId(year, INIT_CONTRACT_LIMIT, status, resellerID).then(resReseller => {
            if (resReseller && resReseller.length) {
              concatVal=[...resReseller]
            }
            getAllfilteredContractYears(year, INIT_CONTRACT_LIMIT, status).then(res => {
              if (res && res.length) {
                if(concatVal.length)
                  concatVal=[...concatVal,...res]
                else
                  concatVal=[...res]
              }
              if (concatVal && concatVal.length) {
                setTableData(customSort(concatVal, sortByKey, sortOrder))
                setContractStatus()
                setLoadingData(false)
              } else {
                setContractStatus('EMPTY')
                setLoadingData(false)
              }
              setStatusDisable(false)
              setIsyearStatus(false)
            })
          })
        })
      } 
      else {
        setStatusDisable(true)
        getAllfilteredContractYears(year, INIT_CONTRACT_LIMIT, status)?.then(res => {
          if (res && res.length) {
            setTableData(customSort(res, sortByKey, sortOrder))
            setContractStatus()
            setLoadingData(false)
          } else {
            setContractStatus('EMPTY')
            setLoadingData(false)
          }
          setStatusDisable(false)
          setIsyearStatus(false)
        })
      } 
    } else if (auth.userInfo.user_id && !hasAccess()) {
      setStatusDisable(true)
      getAssignmentsByUserId(auth.userInfo.user_id)?.then(res => {
        if (res?.length) {
          let arrayOfIds = encodeURIComponent(res)
          getProductionPlan(arrayOfIds,'company_id', true)?.then(productionplans => {
            if (productionplans && productionplans.length) {
              const filteredProdPlan = productionplans.find(
                plan => plan.contract_year.toString() === year
              )
              getAllLinkedContractYears(year, INIT_CONTRACT_LIMIT, status, filteredProdPlan?.production_plan_id).then(res => {
                if (res && res.length) {
                  setTableData(customSort(res, sortByKey, sortOrder))
                  setContractStatus()
                  setLoadingData(false)
                } else {
                  setContractStatus('EMPTY')
                  setLoadingData(false)
                }
                setStatusDisable(false)
                setIsyearStatus(false)
              })
            }
            else {
              setContractStatus('EMPTY')
              setLoadingData(false)
              setStatusDisable(false)
              setIsyearStatus(false)
            }  
          })
        }
      })
    }
  }, [sortByKey, sortOrder, contractYear, statusArr, auth.userInfo.user_id, hasAccess, highestRole])

  return (
    <div className="m25">
      <div className="df jcfe h36">{detailViewButton}</div>
      <div className="mb50">
        <ContractTable
          setStatusArr={setStatusArr}
          filterHandler={year => {
            setContractYear(year)
            setIsyearStatus(true)
          }
          }
          contractYear={contractYear}
          setIsyearStatus={setIsyearStatus}
          match={match}
          history={history}
          data={tableData}
          contractNavigates={true}
          showCreateContract={false}
          status={contractStatus}
          onScrollAPI={getMoreContracts}
          setSortOrder={setSortOrder}
          setSortByKey={setSortByKey}
          customSort={customSort}
          prompt="No data"
          displayCreatedDate={true}
          filterByStatus={true}
          allYears={allYearOptions}
          loadingData={loadingData}
          statusDisable={statusDisable}
        />
      </div>
      <div>
        {hasStewardPermission === 'SUCCESS' && (
          <StewardshipTable
            history={history}
            data={stewardData}
            status={stewardStatus}
          ></StewardshipTable>
        )}
      </div>
      <div data-testid="updateProfileModal">
        <Modal
          autoHeight
          show={showModal}
          handleClose={() => { }} //We want to keep this modal open until they complete the profile in UpdateProfileView
        >
          <div className="bd1-s-black bgc-white h600 p40">
            <UpdateProfileView
              closeHandler={() => {
                setShowModal(false)
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default ContractDashboard